<template>
  <div>
    <b-dropdown-item @click.stop="exibirModalTrocarSenha()">
      <span>
        <i class="fa fa-key"/> Trocar Senha
      </span>
    </b-dropdown-item>

    <b-modal id="modalTrocaSenha" v-model="mostraModalTrocaSenha" @hidden="resetModalTrocarSenha()">
      <div slot="modal-title">Trocar Senha - {{ $store.getters.usuario.nome }}</div>
      <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
      <b-form>
        <b-form-group>
          <label>Usuário</label>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>
                <i class="icon-user"></i>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              :value="$store.getters.usuario.login"
              type="text"
              :disabled="true"
              autocomplete="username"
            ></b-form-input>
          </b-input-group>
        </b-form-group>

        <b-form-group>
          <label>Senha Atual</label>
          <b-form-input
            type="password"
            placeholder="Digite a senha atual"
            v-model="senhaAtual"
            @input="$v.senhaAtual.$touch()"
            :state="$v.senhaAtual.$error ? false : null"
            autocomplete="current-password"
          ></b-form-input>
          <b-form-invalid-feedback>Uma senha é obrigatória</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group>
          <label>Nova Senha</label>
          <b-form-input
            type="password"
            placeholder="Digite a nova senha"
            v-model="senhaNova"
            @input="$v.senhaNova.$touch()"
            :state="$v.senhaNova.$error ? false : null"
            autocomplete="new-password"
          ></b-form-input>
          <b-form-invalid-feedback>Uma senha é obrigatória. Mínimo de 8 caracteres</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group>
          <label>Confirmação da Nova Senha</label>
          <b-form-input
            type="password"
            placeholder="Digite a nova senha do usuário"
            v-model="confirmacaoSenhaNova"
            @input="$v.confirmacaoSenhaNova.$touch()"
            :state="$v.confirmacaoSenhaNova.$error ? false : null"
            autocomplete="new-password"
          ></b-form-input>
          <b-form-invalid-feedback>Erro na confirmação da nova senha</b-form-invalid-feedback>
        </b-form-group>
      </b-form>
      <div slot="modal-footer">
        <b-button variant="secondary" @click.stop="mostraModalTrocaSenha = false">Cancelar</b-button>
        <b-button
          class="ml-2"
          variant="primary"
          :disabled="$v.$invalid"
          @click.stop="salvarSenhaUsuario()"
        >Salvar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import UsuariosServicos from "./UsuariosServicos";

export default {
  name: "usuario-header",
  data() {
    return {
      mostraModalTrocaSenha: false,
      processandoModal: false,
      erros: [],
      senhaAtual: "",
      senhaNova: "",
      confirmacaoSenhaNova: ""
    };
  },

  methods: {
    exibirModalTrocarSenha() {
      this.mostraModalTrocaSenha = true;
    },

    resetModalTrocarSenha() {
      this.senhaAtual = "";
      this.senhaNova = "";
      this.confirmacaoSenhaNova = "";
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },

    salvarSenhaUsuario() {
      this.$store.dispatch("addRequest");
      UsuariosServicos.trocarSenhaUsuario(
        this.$store.getters.usuario.usuarioId,
        { senhaAtual: this.senhaAtual, senhaNova: this.senhaNova }
      ).then(response => {
        if (response) {
          if (response.success) {
            this.$toast.success(
              "Registro atualizado com sucesso!",
              "OK",
              this.$toastConfig.success
            );
            this.mostraModalTrocaSenha = false;
          } else {
            this.erros = response.errors;
          }
        }
        this.$store.dispatch("removeRequest");
      });
    }
  },

  validations: {
    senhaAtual: {
      required
    },
    senhaNova: {
      required,
      minLength: minLength(8)
    },
    confirmacaoSenhaNova: {
      sameAs: sameAs("senhaNova")
    }
  }
};
</script>
